import { Container } from 'components/atoms';
import StatisticsListContainer from 'components/molecules/statistics/StatisticsListContainer';
import { usePermissionGuard } from 'hooks/usePermissionGuard';
import { t } from 'i18next';
import { tracksChartMock } from 'mock/charts/tracksChartMock';
import { PiVinylRecord } from 'react-icons/pi';
import {
  Brush,
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatCurrency } from 'utils/global/currency.utils';
// style={{ backgroundColor: 'var(--background)' }}
const LabelStatistics = () => {
  usePermissionGuard('StatisticsPermissionsLIST**');

  return (
    <div className='flex gap-4 w-full flex-row-reverse'>
      <Container>
        <Container.Header
          title={
            <div className=' flex w-full justify-between'>
              <div className='flex gap-2'>
                <PiVinylRecord /> 1. Master the world
              </div>
            </div>
          }
        />
        <Container.Content>
          <ResponsiveContainer width={'100%'} height={370}>
            <LineChart
              data={tracksChartMock}
              margin={{
                top: 20,
                right: 100,
                bottom: 20,
              }}>
              <CartesianGrid
                strokeDasharray=''
                vertical={false}
                opacity={0.5}
              />
              <XAxis dataKey='name' stroke='var(--secondary-light)' />
              <YAxis
                width={150}
                stroke='var(--secondary-light)'
                tickFormatter={(value: any, index: number) =>
                  value === 0 ? '' : formatCurrency(parseFloat(`${value}`))
                }
                tickCount={5}
              />
              <Tooltip
                cursor={{ fill: 'none' }}
                content={props => (
                  <div
                    className='flex bg-opacity-95 rounded-sm p-8 gap-3'
                    style={{ backgroundColor: 'var(--background)' }}>
                    <p>{`${props.label}`}</p>
                    {props.payload && props.payload[0] && (
                      <>
                        <p>-</p>
                        <p style={{ color: props.payload[0].color }}>
                          {formatCurrency(
                            parseFloat(`${props.payload[0].value}`)
                          )}
                        </p>
                      </>
                    )}
                  </div>
                )}
              />
              <ReferenceLine y={0} stroke='var(--secondary-light)' />
              <Brush dataKey='name' height={20} stroke='var(--primary)' />
              <Line
                type='monotone'
                dataKey='value'
                fill='var(--primary)'
                stroke='var(--primary)'
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Container.Content>
      </Container>

      <StatisticsListContainer
        classname='w-[50%] h-full'
        headerTitle={
          <>
            <PiVinylRecord /> {t('statistics.top-products')}
          </>
        }
        label={item => item.name}
        value={item => formatCurrency(item.value)}
        items={[
          { name: 'Echoes of Tomorrow', value: 14835.09 },
          { name: 'Velvet Skies', value: 12345.23 },
          { name: 'Wanderlust Melody', value: 25890.56 },
          { name: 'Serenade of Shadows', value: 9976.44 },
        ]}
      />
    </div>
  );
};

export default LabelStatistics;
